import { render, staticRenderFns } from "./CartItem.vue?vue&type=template&id=a2c00dbe"
import script from "./CartItem.vue?vue&type=script&lang=ts"
export * from "./CartItem.vue?vue&type=script&lang=ts"
import style0 from "./CartItem.vue?vue&type=style&index=0&id=a2c00dbe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports